var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgVolume = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M10.7369142,8.25 L15.5314787,4.41434839 C16.0225512,4.02149039 16.75,4.37112034 16.75,5 L16.75,19 C16.75,19.6288797 16.0225512,19.9785096 15.5314787,19.5856516 L10.7369142,15.75 L7,15.75 C6.58578644,15.75 6.25,15.4142136 6.25,15 L6.25,9 C6.25,8.58578644 6.58578644,8.25 7,8.25 L10.7369142,8.25 Z M15.25,6.56046864 L11.4685213,9.58565161 C11.3355365,9.69203944 11.1703036,9.75 11,9.75 L7.75,9.75 L7.75,14.25 L11,14.25 C11.1703036,14.25 11.3355365,14.3079606 11.4685213,14.4143484 L15.25,17.4395314 L15.25,6.56046864 Z"
  }));
};
export default SvgVolume;